import { howItWorksSteps } from '@/mocks/homeData';

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-gray-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold tracking-widest text-gold-600 uppercase">How It Works</span>
            <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-navy-600">
              Simple. Powerful. Built for Everyone.
            </h2>
            <p className="mt-4 text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              Whether you are a student or a consultancy, getting started takes less than 5 minutes.
            </p>
          </div>

          <div className="relative">
            {/* Dotted line for desktop */}
            <div className="hidden md:block absolute top-12 left-[16.67%] right-[16.67%] border-t-2 border-dashed border-gold-300" />

            <div className="grid md:grid-cols-3 gap-8 md:gap-12">
              {howItWorksSteps.map((step, index) => (
                <div key={step.step} className="relative text-center">
                  {/* Step number circle */}
                  <div className="relative z-10 w-24 h-24 mx-auto rounded-full bg-white border-2 border-gold-400 flex items-center justify-center shadow-sm">
                    <span className="text-2xl font-bold text-gold-500">{step.step}</span>
                  </div>

                  <div className="mt-6">
                    <h3 className="text-lg md:text-xl font-semibold text-navy-600">{step.title}</h3>
                    <p className="mt-3 text-sm text-gray-500 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}